(function () {
  var root = document.getElementById('falo-configurator');
  if (!root) return;

  var dataEl = document.getElementById('falo-configurator-data');
  if (!dataEl) return;
  var data = JSON.parse(dataEl.textContent);
  var t = data.i18n || {};

  var state = {
    shape: 'sfera',
    size: '100',
    benches: 3,
    step: 0
  };

  var els = {
    shapeCards: root.querySelectorAll('[data-config-shape]'),
    sizeBtns: root.querySelectorAll('[data-config-size]'),
    previewA: root.querySelector('[data-config-preview-a]'),
    previewB: root.querySelector('[data-config-preview-b]'),
    mobileA: root.querySelector('[data-config-mobile-a]'),
    mobileB: root.querySelector('[data-config-mobile-b]'),
    summaryName: root.querySelector('[data-config-summary-name]'),
    summaryPrice: root.querySelector('[data-config-summary-price]'),
    priceBlock: root.querySelector('[data-config-price-block]'),
    summaryIncludes: root.querySelector('[data-config-summary-includes]'),
    benchPersons: root.querySelector('[data-bench-persons]'),
    addBtn: root.querySelector('[data-config-add]'),
    benchContainer: root.querySelector('[data-bench-container]'),
    coverBlock: root.querySelector('[data-config-cover-block]')
  };

  var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var previewActiveIsA = true;
  var mobileActiveIsA = true;
  var imageSwapToken = 0;
  var lastPrice = '';

  function formatPrice(cents) {
    var whole = Math.round(cents / 100);
    var group = t.group || ' ';
    return whole.toString().replace(/\B(?=(\d{3})+(?!\d))/g, group) + ' ' + (t.currency || 'zł');
  }

  function getSystem() {
    return data[state.shape];
  }

  function getSizeData() {
    return getSystem().sizes[state.size];
  }

  function getPersonsPerBench() {
    if (state.shape === 'sfera') return 2;
    var benchSize = getSizeData().benchSize || '140';
    return benchSize === '100' ? 2 : 3;
  }

  function getBenchCapacity() {
    return state.benches * getPersonsPerBench();
  }

  /* Etykieta siedziska pokazywana klientowi.
     SFERA: dlugosc z benchLength na poziomie systemu.
     FORUM: dlugosc z benchSize przypisanego do rozmiaru paleniska (S i M = 100, L i XL = 140). */
  function getBenchLengthCm() {
    if (state.shape === 'sfera') {
      return getSystem().benchLength || '129';
    }
    return getSizeData().benchSize || '140';
  }

  function getBenchTypeLabel() {
    var label = state.shape === 'sfera' ? t.benchSfera : t.benchForum;
    return label + ' ' + getBenchLengthCm() + ' cm';
  }

  function getBenchPrice() {
    var sys = getSystem();
    if (state.shape === 'sfera') {
      return sys.bench.price;
    }
    var benchSize = getSizeData().benchSize || '140';
    return sys.benchSizes[benchSize].price;
  }

  function getBenchVariantId() {
    var sys = getSystem();
    if (state.shape === 'sfera') {
      return sys.bench.variantId;
    }
    var benchSize = getSizeData().benchSize || '140';
    return sys.benchSizes[benchSize].variantId;
  }

  /* Gotowy zestaw dla wybranego rozmiaru. Zwraca null, gdy brak danych,
     wtedy konfigurator liczy wszystko po sztukach jak wczesniej. */
  function getBundle() {
    var sys = getSystem();
    if (!sys.bundles) return null;
    var b = sys.bundles[state.size];
    if (!b || !b.variantId || !b.price || !b.benches) return null;
    return b;
  }

  /* Od liczby siedzisk rownej zestawowi w gore liczymy cene zestawu.
     Ponizej tej liczby liczymy palenisko plus siedziska po sztukach. */
  function getActiveBundle() {
    var b = getBundle();
    if (b && state.benches >= b.benches) return b;
    return null;
  }

  function getExtraBenches() {
    var b = getActiveBundle();
    return b ? (state.benches - b.benches) : 0;
  }

  function getTotalPrice() {
    var b = getActiveBundle();
    if (b) {
      return b.price + (getExtraBenches() * getBenchPrice());
    }
    return getSizeData().price + (state.benches * getBenchPrice());
  }

  function clampBenches() {
    var max = getSystem().maxBenches;
    if (state.benches > max) state.benches = max;
  }

  var imageCache = {};

  function getImageForStep() {
    var sys = getSystem();
    var images = sys.images;
    var fallback = sys.fallbackImage;

    if (state.step === 0) {
      return images.cutout || images.hero || images.pitOnly || fallback;
    }
    if (state.step === 1) {
      return (images.sizes && images.sizes[state.size]) || images.pitOnly || images.hero || fallback;
    }
    if (state.step === 2) {
      var key = state.size + '-' + state.benches;
      return (images.benches && images.benches[key]) ||
        (images.sizes && images.sizes[state.size]) ||
        images.pitOnly ||
        images.hero ||
        fallback;
    }
    return fallback;
  }

  function normalizeSrc(src) {
    if (!src) return '';
    try {
      return new URL(src, window.location.href).href;
    } catch (e) {
      return src;
    }
  }

  function clearImageClasses(img) {
    if (!img) return;
    img.classList.remove('is-entering', 'is-exiting', 'is-active');
  }

  function syncPreviewMode() {
    root.classList.toggle('is-light-preview', state.step >= 1);
    root.classList.toggle('is-shape-step', state.step === 0);
    root.classList.toggle('is-shape-sfera', state.shape === 'sfera');
  }

  function swapImagePair(activeImg, inactiveImg, validSrc, token) {
    if (!activeImg || !inactiveImg) return false;

    var currentSrc = normalizeSrc(activeImg.src);
    var nextSrc = normalizeSrc(validSrc);
    if (currentSrc === nextSrc) return false;

    if (prefersReducedMotion) {
      clearImageClasses(activeImg);
      clearImageClasses(inactiveImg);
      inactiveImg.src = validSrc;
      inactiveImg.classList.add('is-active');
      inactiveImg.removeAttribute('aria-hidden');
      activeImg.removeAttribute('src');
      activeImg.setAttribute('aria-hidden', 'true');
      return true;
    }

    clearImageClasses(inactiveImg);
    inactiveImg.src = validSrc;
    inactiveImg.classList.add('is-entering');
    inactiveImg.removeAttribute('aria-hidden');

    activeImg.classList.remove('is-active');
    activeImg.classList.add('is-exiting');

    function finishSwap() {
      if (token !== imageSwapToken) return;
      clearImageClasses(activeImg);
      clearImageClasses(inactiveImg);
      inactiveImg.classList.add('is-active');
      activeImg.removeAttribute('src');
      activeImg.setAttribute('aria-hidden', 'true');
    }

    var settled = false;
    function onSettled() {
      if (settled) return;
      settled = true;
      inactiveImg.removeEventListener('transitionend', onSettled);
      finishSwap();
    }

    inactiveImg.addEventListener('transitionend', onSettled);
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        inactiveImg.classList.remove('is-entering');
        inactiveImg.classList.add('is-active');
      });
    });

    setTimeout(onSettled, 280);
    return true;
  }

  function setImage(src) {
    var sys = getSystem();
    var fallback = sys.fallbackImage;
    if (!src) src = fallback;

    function applyImage(validSrc) {
      imageSwapToken += 1;
      var token = imageSwapToken;

      var previewActive = previewActiveIsA ? els.previewA : els.previewB;
      var previewInactive = previewActiveIsA ? els.previewB : els.previewA;
      if (swapImagePair(previewActive, previewInactive, validSrc, token)) {
        previewActiveIsA = !previewActiveIsA;
      }

      var mobileActive = mobileActiveIsA ? els.mobileA : els.mobileB;
      var mobileInactive = mobileActiveIsA ? els.mobileB : els.mobileA;
      if (swapImagePair(mobileActive, mobileInactive, validSrc, token)) {
        mobileActiveIsA = !mobileActiveIsA;
      }
    }

    if (imageCache[src] === true) {
      applyImage(src);
    } else if (imageCache[src] === false) {
      applyImage(fallback);
    } else {
      var img = new Image();
      img.onload = function () { imageCache[src] = true; applyImage(src); };
      img.onerror = function () { imageCache[src] = false; applyImage(fallback); };
      img.src = src;
    }
  }

  function renderBenchButtons() {
    if (!els.benchContainer) return;
    var max = getSystem().maxBenches;
    els.benchContainer.innerHTML = '';
    for (var i = 1; i <= max; i++) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'config-bench-btn' + (i === state.benches ? ' is-selected' : '');
      btn.setAttribute('role', 'radio');
      btn.setAttribute('aria-checked', i === state.benches ? 'true' : 'false');
      btn.setAttribute('data-config-bench', i);
      btn.textContent = i;
      btn.addEventListener('click', (function (val) {
        return function () { state.benches = val; update(); };
      })(i));
      els.benchContainer.appendChild(btn);
    }
  }

  function updatePriceUI(total) {
    var formatted = formatPrice(total);
    if (els.summaryPrice && els.summaryPrice.textContent !== formatted) {
      if (els.priceBlock && lastPrice && lastPrice !== formatted) {
        els.priceBlock.classList.remove('is-updating');
        void els.priceBlock.offsetWidth;
        els.priceBlock.classList.add('is-updating');
        window.setTimeout(function () {
          if (els.priceBlock) els.priceBlock.classList.remove('is-updating');
        }, 200);
      }
      if (els.summaryPrice) els.summaryPrice.textContent = formatted;
      lastPrice = formatted;
    }
  }

  function update() {
    clampBenches();
    var total = getTotalPrice();
    var bundle = getActiveBundle();
    var extra = getExtraBenches();
    var shapeName = state.shape === 'sfera' ? 'SFERA' : 'FORUM';
    var sizeLabel = state.shape === 'sfera' ? ('Ø ' + state.size) : (state.size + ' cm');

    els.shapeCards.forEach(function (btn) {
      var val = btn.getAttribute('data-config-shape');
      var selected = val === state.shape;
      btn.setAttribute('aria-checked', selected ? 'true' : 'false');
      btn.classList.toggle('is-selected', selected);
    });

    els.sizeBtns.forEach(function (btn) {
      var val = btn.getAttribute('data-config-size');
      var selected = val === state.size;
      btn.setAttribute('aria-checked', selected ? 'true' : 'false');
      btn.classList.toggle('is-selected', selected);
      if (selected) {
        btn.classList.remove('is-snapping');
        void btn.offsetWidth;
        btn.classList.add('is-snapping');
      }
    });

    if (els.benchPersons) {
      els.benchPersons.textContent = getBenchTypeLabel() + ' · ' + t.upToPersons.replace('[count]', getBenchCapacity());
    }

    if (els.coverBlock) els.coverBlock.hidden = true;

    renderBenchButtons();
    syncPreviewMode();
    setImage(getImageForStep());

    if (els.summaryName) {
      if (bundle) {
        els.summaryName.textContent = bundle.title + (extra > 0 ? ' + ' + extra + ' × ' + t.benchUnit : '');
      } else {
        els.summaryName.textContent = shapeName + ' ' + sizeLabel + ' · ' + state.benches + ' ' + t.benchesSuffix;
      }
    }

    updatePriceUI(total);

    if (els.summaryIncludes) {
      /* includes = "Palenisko + [benches] × [bench] + pokrywa-blat"; free delivery only
         holds for Poland, so the data snippet leaves it empty elsewhere. */
      els.summaryIncludes.textContent =
        t.includes
          .replace('[benches]', state.benches)
          .replace('[bench]', getBenchTypeLabel().toLowerCase()) +
        (t.freeDelivery ? ' · ' + t.freeDelivery : '');
    }
  }

  /* Inquiry-mode countries have no checkout: send the configuration to the
     contact form instead of the cart. */
  function sendInquiry() {
    var subject = els.summaryName ? els.summaryName.textContent : '';
    window.location.href = t.contactUrl + '?zapytanie=' + encodeURIComponent(subject) + '#kontakt';
  }

  function addToCart() {
    if (t.inquiry) {
      sendInquiry();
      return;
    }
    var items = [];
    var bundle = getActiveBundle();
    var extra = getExtraBenches();

    if (bundle) {
      items.push({ id: bundle.variantId, quantity: 1 });
      if (extra > 0) {
        items.push({ id: getBenchVariantId(), quantity: extra });
      }
    } else {
      items.push({ id: getSizeData().variantId, quantity: 1 });
      items.push({ id: getBenchVariantId(), quantity: state.benches });
    }

    var btn = els.addBtn;

    function resetBtn() {
      if (!btn) return;
      btn.classList.remove('is-loading');
      btn.innerHTML = t.addToCart + ' <svg width="14" height="14" viewBox="0 0 16 16" fill="none" aria-hidden="true"><path d="M3 8h10M9 4l4 4-4 4" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';
    }

    /* Bez tej kontroli Shopify moze zwrocic 422, res.json() zadziala poprawnie,
       a klient zobaczy "Dodano" mimo pustego koszyka. */
    var invalid = items.some(function (it) { return !it.id; });
    if (invalid) {
      window.console && console.error('FALO konfigurator: brak variantId dla pozycji', items);
      resetBtn();
      return;
    }

    if (btn) {
      btn.classList.add('is-loading');
      btn.textContent = t.adding;
    }

    fetch(t.cartAddUrl || '/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: items })
    })
    .then(function (res) {
      if (!res.ok) {
        return res.json().then(function (err) { throw new Error(err.description || 'cart error'); });
      }
      return res.json();
    })
    .then(function () {
      if (btn) {
        btn.textContent = t.added;
        setTimeout(function () { window.location.href = t.cartUrl || '/cart'; }, 800);
      }
    })
    .catch(function (e) {
      window.console && console.error('FALO konfigurator:', e);
      resetBtn();
    });
  }

  var observer = new MutationObserver(function() {
    var activeStep = root.querySelector('.config-step.is-active');
    if (activeStep) {
      var newStep = parseInt(activeStep.getAttribute('data-step'), 10);
      if (newStep !== state.step) {
        state.step = newStep;
        syncPreviewMode();
        setImage(getImageForStep());
      }
    }
  });
  observer.observe(root, { subtree: true, attributes: true, attributeFilter: ['class'] });

  els.shapeCards.forEach(function (btn) {
    btn.addEventListener('click', function () {
      state.shape = btn.getAttribute('data-config-shape');
      clampBenches();
      update();
    });
  });

  els.sizeBtns.forEach(function (btn) {
    btn.addEventListener('click', function () {
      state.size = btn.getAttribute('data-config-size');
      update();
    });
  });

  if (els.addBtn) {
    els.addBtn.addEventListener('click', function (e) {
      e.preventDefault();
      addToCart();
    });
  }

  update();
})();